import { jwtDecode } from 'jwt-decode';
export const decodeClientToken = (clientToken) => {
    try {
        const decodedToken = jwtDecode(clientToken);
        const sessionId = decodedToken['session_id'];
        const clientId = decodedToken['client_id'];
        const environment = decodedToken['environment'];
        return {
            sessionId,
            clientId,
            environment,
        };
    }
    catch (error) {
        console.error('Error decoding JWT: ', error.message);
    }
};
